import { REDUX_MODEL_KEY } from '../../constants/key'
import {
  getChangedValueReduxUtil,
  getDataValueReduxUtil
} from '../get-value'
import setUtil from '../../../../utils/set'
import { joinPathsStringUtil } from '../../../../utils/string/get-joined-paths'
import { isEqualUtil } from 'packages/src'

export default function updateReduxUtil (instance, updates) {
  if (!instance) {
    return
  }

  const updateKeys = Object.keys(updates)
  // const associationKeys = getAssociationKeysReduxUtil(instance)
  updateKeys.forEach(updateKey => {
    // const key = associationKeys.includes(updateKey)
    //   ? 'data'
    //   : 'changed'
    const key = REDUX_MODEL_KEY.CHANGED
    const changedValue = getChangedValueReduxUtil(instance, updateKey)
    const dataValue = getDataValueReduxUtil(instance, updateKey)
    const value = updates[updateKey]
    // TODO Workouts get loaded, then workout.changed gets erased
    if (changedValue || !isEqualUtil(dataValue, value)) {
      instance = setUtil(instance, joinPathsStringUtil(key, updateKey), value)
    }
  })

  return {
    ...instance,
    error: null,
    validation: null,
    status: null
  }
}
